module.exports = __webpack_public_path__ + "img/video1.bcff3c95.png";